<template>
	<div class="progress">
		<svg style="width:100%;height: 100%;transform: rotate(-89deg);transform-origin: 50% 50%;transition: all 2s;">
			<circle cx="50%" cy="50%" :r="r" :stroke="bgColor" stroke-width="7px" stroke-linecap="round" fill="transparent"></circle>
			<circle cx="50%" cy="50%" :r="r" stroke-width="7px" :stroke="nowRate < 100 ? color: successColor"
			 :style="`stroke-dasharray: ${arc} ${per}`" stroke-linecap="round" fill="transparent" style="transition: all 2s;"></circle>
		</svg>
		<p class="rateText" :style="rateTextStyle">{{rateText}}</p>
	</div>
</template>

<script type="text/ecmascript-6">
	export default {
		props: {
			r: {
				type: Number,
			},
			bgColor: {
				type: String,
				default: "#F3F3F3"
			},
			color: {
				type: String,
				default: '#35abe3'
			},
			successColor: {
				type: String,
				default: '#87d068'
			},
			nowRate: {
				type: Number,
				default: 100
			},
			rateText: [String, Number],
			rateTextSize: {
				type: Number,
				default: 30
			}
		},
		computed: {
			per() { // 周长
				return parseInt(this.r * Math.PI * 2)
			},
			arc() { // 弧长
				return parseInt(this.per * (this.nowRate === 0 ? 0 : this.nowRate / 100))
			},
			rateStyle() {
				return {
					'stroke-dasharray': (2.9531 * this.nowRate) + 'px,295.31px',
					'stroke-dashoffset': '0px',
					transition: 'stroke-dashoffset 0.3s ease 0s,stroke-dasharray 0.3s ease 0s,stroke 0.3s ease 0s'
				}
			},
			rateTextStyle() {
				return {
					'font-size': this.rateTextSize + 'px',
					'line-height': this.rateTextSize + 'px',
					'height': this.rateTextSize + 'px',
					color: this.nowRate >= 100 ? (this.successColor == undefined ? this.color : this.successColor) : this.color
				}
			}
		},
		mounted() {}
	}
</script>

<style scoped>
	.progress {
		position: relative;
		overflow: hidden;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.progress>.rateText {
		position: absolute;
		z-index: 2;
		text-align: center;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
		font-weight: bold;
	}
</style>
